module.exports = __webpack_public_path__ + "static/media/pending-inner.36f76932.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pending-inner.svg
// module id = ./src/assets/images/pending-inner.svg
// module chunks = 0